import { useEffect } from "react";
import { SidePanel } from "../components/sidePanel/SidePanel";
import { TopPanel } from "../components/TopPanel";
import { FilterComponent } from "../components/sidePanel/FilterComponent";
import { RadioButton } from "../../common/components/Btns/RadioButton";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { changeCurrentProduct } from "../../common/commonSlice";
import { Outlet, useNavigate } from "react-router-dom";
import { FooterServices } from "../../common/components/texts/FooterServices";
import {
  changeActiveComponent,
  changeCurrentFilters,
  selectActivePagareComponent,
  selectCurrentFilterPagareRequest,
} from "./pagareSlice";
import { Category } from "../components/sidePanel/categories/Category";
import { CategoriesComponent } from "../components/sidePanel/categories/CategoriesComponent";
export const Pagares = () => {
  let activeComponent = useAppSelector(selectActivePagareComponent);
  let currentFilteredRequest = useAppSelector(selectCurrentFilterPagareRequest);

  let getFilterItemsByActiveComponent = (): JSX.Element | undefined => {
    if (activeComponent === "Pagares") {
      return (
        <FilterComponent
          key={0}
          hasCalendar={true}
          endDate={
            currentFilteredRequest.endDate
              ? new Date(currentFilteredRequest.endDate)
              : null
          }
          startDate={
            currentFilteredRequest.startDate
              ? new Date(currentFilteredRequest.startDate)
              : null
          }
          setEndDate={(date: Date) => {
            if (date) {
              if (date) {
                dispatch(
                  changeCurrentFilters({
                    ...currentFilteredRequest,
                    endDate: date.toISOString(),
                  })
                );
              }
            }
          }}
          setStartDate={(date: Date) => {
            if (date) {
              if (date) {
                dispatch(
                  changeCurrentFilters({
                    ...currentFilteredRequest,
                    startDate: date.toISOString(),
                  })
                );
              }
            }
          }}
          resetFunction={() => {
            dispatch(
              changeCurrentFilters({
                ...currentFilteredRequest,
                startDate: null,
                endDate: null,
              })
            );
          }}
          items={[
            <div
              key={1}
              className="text-normal text-small primary-color"
              style={{
                alignSelf: "start",
                marginTop: "10px",
                marginBottom: "5px",
              }}
            >
              Tipo de Pagaré
            </div>,
            <div key={2} style={{ alignItems: "center" }}>
              <RadioButton
                label="Blanco con carta"
                checked={currentFilteredRequest.type === "Blank"}
                onClick={() => {
                  if (currentFilteredRequest.type === "Blank") {
                    dispatch(
                      changeCurrentFilters({
                        ...currentFilteredRequest,
                        type: null,
                      })
                    );
                  }
                }}
                onChange={() => {
                  dispatch(
                    changeCurrentFilters({
                      ...currentFilteredRequest,
                      type: "Blank",
                    })
                  );
                }}
              />
              <RadioButton
                label="Diligenciado"
                checked={currentFilteredRequest.type === "FilledOut"}
                onClick={() => {
                  if (currentFilteredRequest.type === "FilledOut") {
                    dispatch(
                      changeCurrentFilters({
                        ...currentFilteredRequest,
                        type: null,
                      })
                    );
                  }
                }}
                onChange={() => {
                  dispatch(
                    changeCurrentFilters({
                      ...currentFilteredRequest,
                      type: "FilledOut",
                    })
                  );
                }}
              />
            </div>,
            <div
              key={3}
              className="text-normal text-small primary-color"
              style={{
                alignSelf: "start",
                marginTop: "10px",
                marginBottom: "5px",
              }}
            >
              Estado
            </div>,
            <div key={4} style={{ alignItems: "center" }}>
              <RadioButton
                label="Creado"
                checked={currentFilteredRequest.status === "Created"}
                onClick={() => {
                  if (currentFilteredRequest.status === "Created") {
                    dispatch(
                      changeCurrentFilters({
                        ...currentFilteredRequest,
                        status: null,
                      })
                    );
                  }
                }}
                onChange={() => {
                  dispatch(
                    changeCurrentFilters({
                      ...currentFilteredRequest,
                      status: "Created",
                    })
                  );
                }}
              />
              <RadioButton
                label="Firmado"
                checked={currentFilteredRequest.status === "Signed"}
                onClick={() => {
                  if (currentFilteredRequest.status === "Signed") {
                    dispatch(
                      changeCurrentFilters({
                        ...currentFilteredRequest,
                        status: null,
                      })
                    );
                  }
                }}
                onChange={() => {
                  dispatch(
                    changeCurrentFilters({
                      ...currentFilteredRequest,
                      status: "Signed",
                    })
                  );
                }}
              />
              <RadioButton
                label="Diligenciado"
                checked={currentFilteredRequest.status === "FilledOut"}
                onClick={() => {
                  if (currentFilteredRequest.status === "FilledOut") {
                    dispatch(
                      changeCurrentFilters({
                        ...currentFilteredRequest,
                        status: null,
                      })
                    );
                  }
                }}
                onChange={() => {
                  dispatch(
                    changeCurrentFilters({
                      ...currentFilteredRequest,
                      status: "FilledOut",
                    })
                  );
                }}
              />
              <RadioButton
                label="Endosado"
                checked={currentFilteredRequest.status === "Endosado"}
                onClick={() => {
                  if (currentFilteredRequest.status === "Endosado") {
                    dispatch(
                      changeCurrentFilters({
                        ...currentFilteredRequest,
                        status: null,
                      })
                    );
                  }
                }}
                onChange={() => {
                  dispatch(
                    changeCurrentFilters({
                      ...currentFilteredRequest,
                      status: "Endosado",
                    })
                  );
                }}
              />
            </div>,
          ]}
        />
      );
    } else {
      return;
    }
  };

  let dispatch = useAppDispatch();
  let navigate = useNavigate();
  useEffect(() => {
    dispatch(changeCurrentProduct("Pagarés"));
    dispatch(changeActiveComponent("Pagares"));
  }, []);
  return (
    <div
      className="flex-col"
      style={{
        paddingLeft: "2%",
        paddingTop: "1%",
        height: "98%",
        width: "98%",
      }}
    >
      <TopPanel />
      <div
        className="flex-row"
        style={{ justifyContent: "start", height: "100%" }}
      >
        <SidePanel
          filter={getFilterItemsByActiveComponent()}
          categories={
            <CategoriesComponent
              categories={[
                <Category
                  key={0}
                  name="Pagarés creados"
                  last
                  selected={activeComponent === "Pagares"}
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/services/pagares/list");
                  }}
                />,
              ]}
            />
          }
        />

        <div
          className="flex-col"
          style={{ width: "80%", justifyContent: "end" }}
        >
          <Outlet />
          <FooterServices />
        </div>
      </div>
    </div>
  );
};
